import OfferList from './OfferList';
import AttributeInfo from './AttributeInfo';

export const StepMap = [
  {
    component: OfferList,
  },
  {
    component: AttributeInfo,
  },
];

export const ComboOpt = [
  {
    value: 'N',
    label: 'No',
  },
  {
    value: 'Y',
    label: 'Yes',
  },
];

export const DefaultPageInfo = {
  currentPage: 1,
  pageSize: 8,
};
